/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";

import IsRtl from "./isRtl";

interface ButtonGroupProps<T = any> {
  items: T[];
  selectedIndex: number;
  onSelect: (index: number) => void;
  labelAccessor: string; // e.g., "fields.FilterValue.value"
  className?: string;
}

// Utility to safely resolve dot notation access
const getValueByAccessor = (obj: any, accessor: string): any => {
  return accessor
    .split(".")
    .reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
};

const ButtonGroup = <T,>({
  items,
  selectedIndex,
  onSelect,
  labelAccessor,
  className = "",
}: ButtonGroupProps<T>) => {
  if (!items || items.length === 0) return null;

  return (
    <div className={`flex flex-wrap ${className}`}>
      {items.map((item, index) => {
        const label = getValueByAccessor(item, labelAccessor);
        if (!label) return null;

        const isSelected = selectedIndex === index;

        return (
          <button
            key={index}
            onClick={() => onSelect(index)}
            className={`animate-top-dga dga-primary-button !rounded-none
              ${
                isSelected
                  ? "!text-white !bg-neutral-950"
                  : "!text-primary-1000 !bg-neutral-100 hover:!bg-neutral-200 active:!bg-neutral-300"
              }
              ${
                IsRtl()
                  ? "border-r border-r-neutral-300 first:border-r-0 first:!rounded-r-lg last:!rounded-l-lg"
                  : "border-l border-l-neutral-300 first:border-l-0 first:!rounded-l-lg last:!rounded-r-lg"
              }
            `}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default React.memo(ButtonGroup);
